import request from '@/utils/request'

let prefetchPromise = null

/**
 * 启动挑战列表首页预取，用于改善 LCP（h3.challenge-title）。
 * 在应用启动且用户已登录时调用，与首屏渲染并行执行。
 */
export function startChallengesPrefetch() {
  if (prefetchPromise != null) return
  prefetchPromise = request
    .get('/challenges', { params: { current: 1, size: 10 } })
    .then((data) => data)
    .catch(() => null)
}

/**
 * 取走预取结果（仅能消费一次），Challenges 页挂载时调用。
 * @returns {Promise<{ records: any[], total: number } | null>}
 */
export function takePrefetchedChallenges() {
  const p = prefetchPromise
  prefetchPromise = null
  return p || Promise.resolve(null)
}
